import {VueConstructor} from "vue";
import Toolbar from "@/components/Toolbar.vue";
import ToolbarButton from "@/components/ToolbarButton.vue";
import Spinner from "@/components/Spinner.vue";
import Pager from "@/components/Pager.vue";
import FlotChart from "@/components/FlotChart.vue";
import BarChart from "@/components/BarChart.vue";
import PieChart from "@/components/PieChart.vue";
import DoughnutChart from '@/components/DoughnutChart.vue';
import PrintDialog from '@/components/PrintDialog.vue'

function install(vue: VueConstructor) {
    vue.component('mf-toolbar', Toolbar);
    vue.component('mf-button', ToolbarButton);
    vue.component('mf-spinner', Spinner);
    vue.component('mf-pager', Pager);
    vue.component('mf-flotchart', FlotChart);
    vue.component('mf-barchart', BarChart);
    vue.component('mf-piechart', PieChart);
    vue.component('mf-donutchart', DoughnutChart);
    vue.component('mf-print-dialog', PrintDialog);
}

export default install;
